import { render, staticRenderFns } from "./FollowButton.vue?vue&type=template&id=5f4209e2&scoped=true"
import script from "./FollowButton.vue?vue&type=script&lang=js"
export * from "./FollowButton.vue?vue&type=script&lang=js"
import style0 from "./FollowButton.vue?vue&type=style&index=0&id=5f4209e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4209e2",
  null
  
)

export default component.exports